<template>
  <div class="animated fadeIn col-md-12">
    <b-row>
      <b-col>
        <b-card bg-variant="light" header="Light" class="text-center">
          <div slot="header">
            <b-form-select class="w-25 float-right" v-model="selected" :options="options"></b-form-select>
            <div class="d-flex float-left">
                <div><button type="button"  class="btn btn-primary btn-block">امروز</button></div>
              <div class="d-flex">
                  
                <span class="p-2"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
                <span class="p-2"><i class="fa fa-angle-left" aria-hidden="true"></i></span>
              </div>
              <div class="d-flex align-items-center">1397/8/3</div>
            </div>
          </div>
          <scheduler :kindscheduler="selected" />

        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import scheduler from './scheduler'
  export default {
    components: {
      scheduler
    },
    name: "schedulerPage",
    data() {
      return {
        selected: "day",
        options: [{
            value: null,
            text: 'Please select an option'
          },
          {
            value: 'day',
            text: this.$lang.day
          },
          {
            value: 'weak',
            text: 'هفته'
          },
          {
            value: 'month',
            text: 'ماهانه',
            disabled: true
          }
        ]
      }
    },
    methods: {

    }
  }

</script>
